<app-section sectionTitle="Inputs">
  <!-- MARK: Actions & Filters -->
  <app-subsection subSectionTitle="Actions & Filters">
    <div style="display: flex; flex-direction: column; gap: 16px">
      <div style="display: flex; flex-wrap: wrap; align-items: start">
        <button
          class="form-item-button"
          style="align-self: center; margin: 0px"
          mat-mini-fab
          (click)="craftCalculatorStateService.refreshCraftGroupPrices()"
          [disabled]="this.craftCalculatorStateService.disableButtons() || this.craftCalculatorStateService.craftGroup().inputOutputItemsUniqueNames().length === 0"
          color="primary"
          aria-label="Clear All Button"
          matTooltip="Refresh Prices"
        >
          <mat-icon>refresh</mat-icon>
        </button>
        <button
          class="form-item-button"
          style="align-self: center; margin: 0px 0px 0px 10px"
          mat-mini-fab
          (click)="craftCalculatorStateService.craftGroup().setAllInputPricesToAodp()"
          color="primary"
          aria-label="Clear All Button"
          matTooltip="Set All Prices to AODP"
        >
          <mat-icon>share</mat-icon>
        </button>
        <div style="display: flex; flex-direction: column; margin: 0px 0px 0px 10px">
          <mat-checkbox style="margin-right: 10px" [(ngModel)]="craftCalculatorStateService.craftGroup().hideUnusedItems">Hide Unused</mat-checkbox>
          <mat-checkbox style="margin-right: 10px" [(ngModel)]="craftCalculatorStateService.craftGroup().onlyMissingPricesItems">Only Missing Prices</mat-checkbox>
        </div>
        <div style="display: flex; flex-direction: column; margin: 0px 0px 0px 10px">
          <mat-checkbox style="margin-right: 10px" [(ngModel)]="craftCalculatorStateService.craftGroup().showCharts">Show Charts</mat-checkbox>
        </div>
      </div>
      <mat-form-field style="width: 98%">
        <mat-label>Text Filter</mat-label>
        <input matInput type="text" [(ngModel)]="searchText" />
        @if (searchText()) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="searchText.set('')" aria-label="Clear Crafts Search">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </app-subsection>
  <!-- MARK: Tbale -->
  <app-subsection subSectionTitle="Inputs Table">
    @defer {
      <div class="table mat-elevation-z8">
        <table mat-table [dataSource]="dataSource()" #sort="matSort" matSort matSortStart="desc">
          <!-- Item -->
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Item</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; align-items: center">
                <div style="display: flex; flex-direction: column; align-items: center; padding-right: 5px; padding-top: 3px">
                  <app-item-image [item]="input.item" [size]="50" [hideTooltip]="true" />
                </div>
                <div style="display: flex; flex-direction: column; align-items: start; text-align: start">
                  <div>
                    {{ input.item.localizedName }}
                  </div>
                  <div>
                    <app-copy-text-button [text]="input.item.localizedName"></app-copy-text-button>
                    <app-check-price-button [itemUniqueName]="input.item.uniqueName"></app-check-price-button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Amount -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">
              Amount <br />
              (Leftovers)
            </th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <div>{{ input.totalAmount() | number: '1.2-2' }}</div>
                <div style="margin-top: 4px">({{ input.totalLeftOvers() | number: '1.2-2' }})</div>
              </div>
            </td>
          </ng-container>

          <!-- Buy Location -->
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Buy Location</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
                  <mat-form-field style="width: 240px">
                    <mat-label>Buy Location</mat-label>
                    <mat-select [(ngModel)]="input.buyLocation">
                      @for (location of craftCalculatorStateService.royalMarketLocations; track location.index) {
                        <mat-option [value]="location">{{ location.displayName }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <div style="display: flex; flex-direction: column">
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!input.buyLocation() ? 0.4 : 1"
                      [style.cursor]="!input.buyLocation() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to All Input Prices"
                      [disabled]="!input.buyLocation()"
                      (click)="this.craftCalculatorStateService.propagateLocation(input.buyLocation()!, 'input')"
                    >
                      <mat-icon>share</mat-icon>
                    </button>
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!input.buyLocation() ? 0.4 : 1"
                      [style.cursor]="!input.buyLocation() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to Input Prices of Same Category"
                      [disabled]="!input.buyLocation()"
                      (click)="this.craftCalculatorStateService.propagateLocation(input.buyLocation()!, 'input', input.item.groupUniqueName)"
                    >
                      <mat-icon>send</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Buy Price Type -->
          <ng-container matColumnDef="pricetype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Buy From</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
                  <mat-form-field style="width: 240px">
                    <mat-label>Buy Price Type</mat-label>
                    <mat-select [(ngModel)]="input.buyPriceType">
                      @for (type of craftCalculatorStateService.priceTypes; track type.name) {
                        <mat-option [value]="type">{{ type.friendlyName }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div style="display: flex; flex-direction: column">
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!input.buyPriceType() ? 0.4 : 1"
                      [style.cursor]="!input.buyPriceType() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to All Input Prices"
                      [disabled]="!input.buyPriceType()"
                      (click)="this.craftCalculatorStateService.propagatePriceType(input.buyPriceType()!, 'input')"
                    >
                      <mat-icon>share</mat-icon>
                    </button>
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!input.buyPriceType() ? 0.4 : 1"
                      [style.cursor]="!input.buyPriceType() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to Input Prices of Same Category"
                      [disabled]="!input.buyPriceType()"
                      (click)="this.craftCalculatorStateService.propagatePriceType(input.buyPriceType()!, 'input', input.item.groupUniqueName)"
                    >
                      <mat-icon>send</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- Left Overs Sell Price Type -->
          <ng-container matColumnDef="selltype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Sell Leftovers to</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
                  <mat-form-field style="width: 240px">
                    <mat-label>Left Overs Sell Price Type</mat-label>
                    <mat-select [(ngModel)]="input.leftOverSellPriceType">
                      @for (type of craftCalculatorStateService.priceTypes; track type.name) {
                        <mat-option [value]="type">{{ type.friendlyName }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <div style="display: flex; flex-direction: column">
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!input.leftOverSellPriceType() ? 0.4 : 1"
                      [style.cursor]="!input.leftOverSellPriceType() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to All Left Overs Prices "
                      [disabled]="!input.leftOverSellPriceType()"
                      (click)="this.craftCalculatorStateService.propagatePriceType(input.leftOverSellPriceType()!, 'leftOvers')"
                    >
                      <mat-icon>share</mat-icon>
                    </button>
                    <button
                      style="color: var(--accent-color)"
                      [style.opacity]="!input.leftOverSellPriceType() ? 0.4 : 1"
                      [style.cursor]="!input.leftOverSellPriceType() ? 'not-allowed' : 'pointer'"
                      mat-icon-button
                      class="mat-icon-button small-icon-button"
                      matTooltip="Propagate Value to Left Overs Prices of Same Category"
                      [disabled]="!input.leftOverSellPriceType()"
                      (click)="this.craftCalculatorStateService.propagatePriceType(input.leftOverSellPriceType()!, 'leftOvers', input.item.groupUniqueName)"
                    >
                      <mat-icon>send</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- AODP Price -->
          <ng-container matColumnDef="aodpprice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">AODP Price</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center">
                  <div style="display: flex; flex-direction: column; gap: 6px">
                    <span>{{ input.aodpPrice() ?? 0 | number: '1.2-2' }}</span>
                    @if (input.aodpPriceAge()) {
                      <span>{{ formatHoursAndMinutes(input.aodpPriceAge()) }} old</span>
                    }
                    @if (input.aodpAverage().averageAmount) {
                      <span>{{ input.aodpAverage().averageAmount | smallNumber }} / day</span>
                    }
                  </div>
                  <button style="color: var(--accent-color)" mat-icon-button class="mat-icon-button small-icon-button" matTooltip="Set as Your Buy Price" (click)="input.buyUserPrice.set(input.aodpPrice() ?? 0)">
                    <mat-icon>send</mat-icon>
                  </button>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- User Price -->
          <ng-container matColumnDef="userprice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">User Price</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <mat-form-field style="max-width: 120px">
                  <mat-label>Your Buy Price</mat-label>
                  <input matInput type="number" step="1" min="0" [(ngModel)]="input.buyUserPrice" />
                </mat-form-field>
              </div>
            </td>
          </ng-container>

          <!-- Chart -->
          <ng-container matColumnDef="chart">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Chart</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; flex-direction: column; min-width: 180px; align-items: center; justify-content: center">
                <app-spark-line-chart
                  class="width-100"
                  [chosenPrice]="input.buyUserPrice()"
                  [histories]="input.craftGroup.marketHistoriesResponses()"
                  [item]="input.item"
                  [location]="input.buyLocation()"
                  [showButton]="false"
                  [showChart]="true"
                  [hideAmCharts]="true"
                />
              </div>
            </td>
          </ng-container>

          <!-- Left Overs -->
          <ng-container matColumnDef="leftover">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Left Overs</th>
            <td mat-cell *matCellDef="let input">
              <div style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                <div style="display: flex; flex-direction: row; align-items: center">
                  <div>AODP Price: {{ input.leftOverAodpPrice() | number: '1.2-2' }}</div>
                  <button style="color: var(--accent-color)" mat-icon-button class="mat-icon-button small-icon-button" matTooltip="Set as Your Buy Price" (click)="input.sellUserPrice.set(input.leftOverAodpPrice() ?? 0)">
                    <mat-icon>arrow_downward</mat-icon>
                  </button>
                </div>
                <mat-form-field style="max-width: 120px">
                  <mat-label>Your Sell Price</mat-label>
                  <input matInput type="number" step="1" min="0" [(ngModel)]="input.sellUserPrice" />
                </mat-form-field>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
          <tr mat-footer-row></tr>
        </table>
      </div>
      <div>
        <mat-paginator #paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="Select page of crafts"> </mat-paginator>
      </div>
    } @placeholder {
      <p>Hold tight</p>
    }
  </app-subsection>
</app-section>
